import { inject, Injectable } from '@angular/core';
import { RestRequestService } from '@app/restApi/rest-request.service';
import { REST_PROJECTS, REST_RFI } from '@app/restApi/RestRoutes';
import {
  CreateUpdateRFIModel,
  RFI,
  RFIFilterParams,
  RFIListingItem,
} from '@app/store/rfis/rfi.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RfiApiService {
  rest = inject(RestRequestService);
  DEFAULT_PER_PAGE = 20;

  loadRfiLog(projectId: number, filters?: RFIFilterParams): Observable<RFIListingItem[]> {
    const params = this.getQueryParams(filters);
    return this.rest.getWithObservable(`${REST_PROJECTS}/${projectId}/rfi`, {}, params);
  }

  getRFIDetails(rfiId: number): Observable<RFI> {
    return this.rest.getWithObservable(`${REST_RFI}/${rfiId}`);
  }

  createRfi(metadata: CreateUpdateRFIModel) {
    return this.rest.postWithObservable(REST_RFI, metadata);
  }

  updateRfi(rfiId: number, metadata: Partial<CreateUpdateRFIModel>) {
    return this.rest.patchWithObservable(`${REST_RFI}/${rfiId}`, metadata);
  }

  setRFIResponsibleSeenStatus(rfiId: number): Observable<RFI> {
    return this.rest.patchWithObservable(`${REST_RFI}/${rfiId}/mark-responsible-seen`, {});
  }

  deleteRfi(rfiId: number) {
    return this.rest.delWithObservable(`${REST_RFI}/${rfiId}`);
  }

  getNextRFINumber(projectId: number): Observable<{ next_id: string }> {
    return this.rest.getWithObservable(`${REST_PROJECTS}/${projectId}/next-id/rfi`);
  }

  getQueryParams(filters?: RFIFilterParams): Record<string, any> {
    if (!filters) {
      return {
        perPage: this.DEFAULT_PER_PAGE,
        page: 1,
      };
    }

    const params: any = {};

    params.perPage = filters.perPage ?? this.DEFAULT_PER_PAGE;
    params.page = filters.page ?? 1;
    if (filters.status) params['status[]'] = filters.status;
    if (filters.rfi_manager_id) params.rfi_manager_id = filters.rfi_manager_id;
    if (filters.rfi_responsible_id) params['rfi_responsible_id[]'] = filters.rfi_responsible_id;
    if (filters.search) params.search = filters.search;
    if (filters.sortBy) params.sortBy = filters.sortBy;
    if (filters.sortDirection) params.sortDirection = filters.sortDirection;

    return params;
  }
}
